import { render, staticRenderFns } from "./faq_category.vue?vue&type=template&id=4cb05d15&"
import script from "./faq_category.vue?vue&type=script&lang=js&"
export * from "./faq_category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports